module.exports = __webpack_public_path__ + "static/media/selector.37489709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/selector.jpg
// module id = 5482
// module chunks = 0